import React from 'react'

import { Badge } from '..'
import * as colors from '../../assets/js/colors'

function BadgeStatusCte({ status, description }) {
  switch (status) {
    case 'erro_autorizacao':
      return (
        <>
          <Badge color={colors.vermelho_hover}>Erro ao Autorizar</Badge>
          <span style={{ marginLeft: '10px' }}>{description}</span>
        </>
      )
    case 'autorizado':
      return (
        <>
          <Badge color={colors.verde_success}>Autorizado</Badge>
          <span style={{ marginLeft: '10px' }}>{description}</span>
        </>
      )
    case 'cancelado':
      return (
        <>
          <Badge color={colors.gray}>Cancelado</Badge>
          <span style={{ marginLeft: '10px' }}>{description}</span>
        </>
      )
    case 'processando_autorizacao':
      return (
        <>
          <Badge color={colors.azul}>Processando</Badge>
          <span style={{ marginLeft: '10px' }}>{description}</span>
        </>
      )
    case 'denegado':
      return (
        <>
          <Badge color={colors.vermelho}>Denegado</Badge>
          <span style={{ marginLeft: '10px' }}>{description}</span>
        </>
      )

    case 'encerrado':
      return (
        <>
          <Badge color={colors.violeta}>Encerrado</Badge>
          <span style={{ marginLeft: '10px' }}>{description}</span>
        </>
      )
    case 'substituido':
      return (
        <>
          <Badge color={colors.azul_escuro}>Substituído</Badge>
          <span style={{ marginLeft: '10px' }}>{description}</span>
        </>
      )
    default:
      return null
  }
}

export default BadgeStatusCte
